import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function useSeo(title, description, options = {}) {
  const { image, url, ogTitle, ogDescription } = options;
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    const ot = ogTitle || title;
    const od = ogDescription || description;
    if (ot) {
      upsertMeta("property", "og:title", ot);
      upsertMeta("name", "twitter:title", ot);
    }
    if (od) {
      upsertMeta("property", "og:description", od);
      upsertMeta("name", "twitter:description", od);
    }
    if (image) {
      upsertMeta("property", "og:image", image);
      upsertMeta("name", "twitter:image", image);
    }
    if (url) upsertMeta("property", "og:url", url);
  }, [title, description, image, url, ogTitle, ogDescription]);
}
